var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 28.3333C6.52918 28.3333 0 21.9906 0 14.1667C0 6.34263 6.52918 0 14.5833 0C22.6374 0 29.1667 6.34263 29.1667 14.1667C29.1667 21.9906 22.6374 28.3333 14.5833 28.3333ZM13.1288 19.8333L23.4408 9.81598L21.3784 7.81252L13.1288 15.8264L9.00406 11.8194L6.94165 13.823L13.1288 19.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivated);
export default __webpack_public_path__ + "static/media/activated.a3acc7f401ad8843e2f92fe1d1df6378.svg";
export { ForwardRef as ReactComponent };